import React from "react";
import { forwardRef } from "react";
import { Icon, IconProps } from "./common";

const MeetingRoom: Icon = forwardRef<SVGSVGElement, IconProps>(({ color = "currentColor", size = 20, ...rest }, ref) => <svg ref={ref} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
   <g stroke={color} strokeLinecap="round">
      <path strokeWidth="1.5" d="M4.375 16.875V9.301c0-.5.56-.798.975-.518L9.9 11.855c.22.148.51.141.722-.017l4.004-2.972a.625.625 0 0 1 .998.501v7.508M6.875 13.125v3.75M12.5 13.125v3.75" />
      <circle cx="5" cy="5" r="1.275" strokeWidth="1.2" />
      <circle cx="15" cy="5" r="1.275" strokeWidth="1.2" />
   </g>
</svg>);
export default MeetingRoom;